const ready = (callback) => {
  if (window && window.analytics) window.analytics.ready(callback);
};

export const identify = (userId, traits) => {
  if (window && window.analytics) ready(() => window.analytics.identify(userId, traits));
};

export const page = (properties) => {
  if (window && window.analytics) ready(() => window.analytics.page(properties));
};

export const track = (event, properties) => {
  if (window && window.analytics) ready(() => window.analytics.track(event, properties));
};
